export const touchEvent = {
    data() {
        return {
            touchXStart: 0,
            moveXdist: 0,
            touchYStart: 0,
            moveYdist: 0,
            touchElementClass: '',
        }
    },
    beforeMount() {
        window.addEventListener("touchstart", this.eventTouchStart, false);
        window.addEventListener("touchmove", this.eventTouchMove, false);
        window.addEventListener("touchend", this.eventTouchMoveEnd, false);
    },
    beforeUnmount() {
        window.removeEventListener("touchstart", this.eventTouchStart, false);
        window.removeEventListener("touchmove", this.eventTouchMove, false);
        window.removeEventListener("touchend", this.eventTouchMoveEnd, false);
    },
    methods: {
        eventTouchStart(event) {
            this.touchElementClass = event.srcElement.className;
            this.touchXStart = event.touches[0].clientX;
            this.moveXdist = 0;
            this.touchYStart = event.touches[0].clientY;
            this.moveYdist = 0;
            this.touchStartEvent();
        },
        touchStartEvent(){

        },
        eventTouchMove(event) {
            if(!this.touchXStart || !this.touchYStart) {
                return;
            }
            this.moveXdist = event.touches[0].clientX - this.touchXStart;
            this.moveYdist = event.touches[0].clientY - this.touchYStart;
        },
        eventTouchMoveEnd(event) {
            if(this.moveXdist < -50){
                this.moveTouchLeft();
            }
            if(this.moveXdist > 50){
                this.moveTouchRight();
            }
            if(this.moveYdist > 50){
                this.moveTouchDown();
            }
            if(this.moveYdist < -50){
                this.moveTouchUp();
            }
        },
        moveTouchLeft(){
        },
        moveTouchRight(){
        },
        moveTouchUp(){
        },
        moveTouchDown(){
        }
    }
}
